var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.46616V3.99992H5C2.79086 3.99992 1 5.79078 1 7.99992C1 8.63942 1.1497 9.24252 1.41552 9.77741C1.53841 10.0247 1.43757 10.3248 1.19028 10.4477C0.942987 10.5706 0.642895 10.4697 0.520003 10.2224C0.187005 9.55237 0 8.79727 0 7.99992C0 5.2385 2.23858 2.99992 5 2.99992H11V1.53368C11 1.32172 11.2472 1.20593 11.41 1.34163L13.7695 3.30787C13.8895 3.40781 13.8895 3.59203 13.7695 3.69198L11.41 5.65822C11.2472 5.79391 11 5.67812 11 5.46616Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8097 5.55217C15.057 5.42927 15.3571 5.53012 15.48 5.77741C15.813 6.44748 16 7.20258 16 7.99992C16 10.7613 13.7614 12.9999 11 12.9999H5V14.4662C5 14.6781 4.75279 14.7939 4.58995 14.6582L2.23047 12.692C2.11053 12.592 2.11053 12.4078 2.23047 12.3079L4.58995 10.3416C4.75279 10.2059 5 10.3217 5 10.5337V11.9999H11C13.2091 11.9999 15 10.2091 15 7.99992C15 7.36043 14.8503 6.75733 14.5845 6.22244C14.4616 5.97515 14.5624 5.67506 14.8097 5.55217Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessGrey);
export default __webpack_public_path__ + "static/media/process-grey.f7c66810e8ccc660afa848624deff3f3.svg";
export { ForwardRef as ReactComponent };